/**
 * Utility function for conditionally joining class names together.
 * Filters out falsy values and joins the rest with spaces.
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
